import { useTranslation } from "react-i18next";
import { Videos as VideosFeature } from "@/partner/features/videos";
import { Meta } from "@/shared/components";

export function VideosPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("videos.pageTitle")} pageType="Partner" />
      <VideosFeature />
    </>
  );
}
